module.exports = __webpack_public_path__ + "static/media/avatarSample.1afb1ae3.png";